import { useState } from "react";
import type { FaqItem } from "@/mocks/content";
import { cn } from "@/utils/format";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
  className?: string;
}

export default function FaqAccordion({ items, defaultOpenId, className }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className={cn("flex flex-col divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50", className)}>
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                aria-controls={`panel-${item.id}`}
                className="flex w-full cursor-pointer items-start justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70 md:px-6"
              >
                <span className="flex items-start gap-3">
                  <i
                    className="ri-question-line mt-0.5 shrink-0 text-primary-500"
                    aria-hidden="true"
                  />
                  <span className="font-heading text-sm font-bold leading-relaxed text-foreground-950 md:text-base">
                    {item.question}
                  </span>
                </span>
                <i
                  className={cn(
                    "mt-0.5 shrink-0 text-lg text-foreground-500 transition-transform duration-300",
                    isOpen ? "ri-subtract-line" : "ri-add-line"
                  )}
                  aria-hidden="true"
                />
              </button>
            </h3>
            <div
              id={`panel-${item.id}`}
              hidden={!isOpen}
              className="px-5 pb-5 pl-[3.1rem] md:px-6 md:pb-6 md:pl-[3.35rem]"
            >
              <p className="text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                {item.answer}
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap text-[11px] text-foreground-400">
                <i className="ri-folder-line" aria-hidden="true" />
                {item.group}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}